export default __webpack_public_path__ + "static/media/css3.39769a8b.svg";